<template>
  <b-input-group
    class="!w-fit"
    size="lg"
  >
    <input
      v-for="(_, index) in digits"
      :key="index"
      :ref="'digit-' + index"
      :value="digits[index]"
      maxlength="1"
      type="text"
      class="form-control text-center"
      :class="{
        '!rounded-xl': digits.length === 1,
        '!rounded-s-xl': digits.length > 1 && index === 0,
        '!rounded-e-xl': digits.length > 1 && index === digits.length - 1
      }"
      @input="handleInput(index, $event)"
      @keydown.backspace="handleBackspace(index)"
      @focus="isEmptyInput && index === 0"
    >
  </b-input-group>
</template>

<script>
export default {
  name: 'DigitInputGroup',
  props: {
    length: {
      type: Number,
      default: 6,
    },
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      digits: Array(this.length).fill(''),
    }
  },
  computed: {
    isEmptyInput() {
      return this.digits.every(d => !d)
    },
  },
  mounted() {
    if (this.value) {
      this.value
        .split('')
        .slice(0, this.length)
        .forEach((digit, index) => {
          this.$set(this.digits, index, digit)
        })
    }
  },
  methods: {
    handleInput(index, event) {
      const { value } = event.target

      const currentValue = value.replace(/\D/g, '').substring(0, 1)

      this.$set(this.digits, index, currentValue)

      this.$emit('input', this.digits.join(''))

      if (currentValue && index < this.length - 1) {
        this.$refs[`digit-${index + 1}`][0].focus()
      }

      if (this.digits.every(item => item !== '')) {
        this.$emit('complete', this.digits.join(''))
      }
    },

    handleBackspace(index) {
      if (!this.digits[index] && index > 0) {
        this.$refs[`digit-${index - 1}`][0].focus()
      }
    },
  },
}
</script>

<style scoped>
.form-control {
  width: 50px;
  max-width: 50px;
}
</style>
